const CapTableIcon = () => (
  <svg style={{ width: 16, height: 'auto' }} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <path d="M21 12a9 9 0 1 1-9-9"/>
    <path d="M21 3v9h-9"/>
    <path d="M21 12A9 9 0 0 0 12 3"/>
  </svg>
);

export default CapTableIcon;
